import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Inscription,
  Label,
  RegularField,
  useFormContext,
} from '@common-fe/common-fe';

import {
  CreateMainContactField,
  CreateMainContactForm,
} from '@/modules/ExpressSetup/ExpressSetupSignUp/hooks/useCreateMainContactForm';

const SecurityForm = () => {
  const { control, formState: { errors } } = useFormContext<CreateMainContactForm>();

  return (
    <Box
      pad={{ vertical: 'spacing24', horizontal: 'spacing32' }}
      background="canvas"
      round="container1Round"
    >
      <Inscription size="xxlarge" lineHeight="40px">
        Security
      </Inscription>

      <FormFieldsContainer margin={{ top: 'spacing16' }}>
        <FieldWrapper>
          <Label name={CreateMainContactField.password} size="large" showRequireIcon>
            Password
          </Label>
          <ControllerWrapper errorText={errors?.[CreateMainContactField.password]?.message}>
            <Controller
              name={CreateMainContactField.password}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={CreateMainContactField.password}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Password"
                  isError={!!errors?.[CreateMainContactField.password]?.message}
                  style={{ width: '320px' }}
                  passwordHelper
                  passwordHelperLeftPosition
                  type="password"
                  editMode
                  isLarge
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateMainContactField.confirmPassword} size="large" showRequireIcon>
            Confirm password
          </Label>
          <ControllerWrapper errorText={errors?.[CreateMainContactField.confirmPassword]?.message}>
            <Controller
              name={CreateMainContactField.confirmPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={CreateMainContactField.confirmPassword}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Confirm password"
                  isError={!!errors?.[CreateMainContactField.confirmPassword]?.message}
                  style={{ width: '320px' }}
                  type="password"
                  editMode
                  isLarge
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default SecurityForm;
